//export const BASE_URL = 'http://10.11.0.13:8080/envio-datos/';
//export const BASE_URL = 'http://localhost:8080/envio-datos/';
//export const BASE_URL = 'https://quadrumdesarrollo.com.mx/envio-datos/';
export const BASE_URL = 'https://enlaceredidse.com.mx/envio-datos/';
export const TOKEN_QUADRUM_IMSS="TokenQImss";
export const USUARIO_KEY="UserQuadrumImss"
export const BEARER="Bearer ";

export const CALENDARIO_ES_MX = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    today: "Hoy",
    clear: "Claro"
};

export const FORMATO_FECHA_CALENDAR="dd/mm/yy";

export const DEFAULT_MASKS = {
    pint: /[\d]/,
    int: /[\d\-]/,
    pnum: /[\d\.]/,
    money: /[\d\.\s,]/,
    num: /[\d\-\.]/,
    hex: /[0-9a-f]/i,
    email: /[a-z0-9_\.\-@]/i,
    alpha: /[a-z]/i,
    alphanum: /[a-z0-9]/i,
    alphaspace:/[a-z ñÑ]/i,
    modenaidse:/(^[0-9]{1,4})+(\.[0-9]{0,2})?$/,
    nombreIdse:/[a-z ñÑ\.\-]/i
};

export const EXPRESION_RFC = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/;
